type LiteralOptions<T extends string> = {
  [P in T]: P;
};

export const parseLiteral = <T extends string>(
  value: string | undefined | null,
  options: LiteralOptions<T>,
): T | undefined => {
  if (!value) {
    return undefined;
  }

  return options[value as T] ?? undefined;
};
